export const HUB_MAPPING: { [key: number]: string } = {
  1: 'BKK',
  2: 'SC',
  3: 'TM',
  4: 'TK',
  5: 'W5',
  6: 'PH',
  7: 'CC',
  8: 'RK',
  9: 'CD',
  10: 'HQ',
  11: 'SHV',
};
